export default __webpack_public_path__ + "assets/06ea7b66106f1b0c4616b35825897045.png";